import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=fae6363a&scoped=true"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae6363a",
  null
  
)

export default component.exports